module.exports = __webpack_public_path__ + "static/media/task4Planet3.966be02f.png";